import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TZyutyuHaisyaPatternGetRes,
  TZyutyuHaisyaPatternListGetByCodeReq,
  TZyutyuHaisyaPatternListGetReq,
  TZyutyuHaisyaPatternListGetRes,
  TZyutyuHaisyaPatternPutReq,
} from "./TZyutyuHaisyaPattern"

/**
 * 品名マスタに対するAPIリクエスト用サービス
 *
 * @export
 * @class MenuService
 * @extends {ConnectApi}
 */
export default class ZyutyuHaisyaPatternService extends ConnectApi {
  /**
   * 検索取得
   *
   * @param {TMenuInfoGetReq} params
   * @memberof MenuService
   */
  getList = async (params: TZyutyuHaisyaPatternListGetReq) => {
    try {
      const res: AxiosResponse<TApiResponse<TZyutyuHaisyaPatternListGetRes[]>> =
        await this.getInner(`/order/zyutyuhaisyapattern`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体取得
   *
   * @param {TMenuInfoGetReq} params
   * @memberof MenuService
   */
  get = async (id: string | number) => {
    try {
      //TODO: api実装必要
      const res: AxiosResponse<TApiResponse<TZyutyuHaisyaPatternGetRes>> =
        await this.getInner(`/order/zyutyuhaisyapattern/${id}`)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体取得(コード取得)
   *
   * @param {TMenuInfoGetReq} params
   * @memberof MenuService
   */
  getByCode = async (params: TZyutyuHaisyaPatternListGetByCodeReq) => {
    try {
      //TODO: api実装必要
      const res: AxiosResponse<TApiResponse<TZyutyuHaisyaPatternGetRes>> =
        await this.getInner(
          `/order/zyutyuhaisyapattern/actions/getbycode`,
          params
        )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 単体更新
   *
   * @param {TZyutyuHaisyaPatternPutReq} data
   * @param {(param: TApiResponse<TKyotenRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TKyotenRes>>) => any} reject
   * @memberof KyotenService
   */
  put = async (id: string, data: TZyutyuHaisyaPatternPutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `/order/zyutyuhaisyapattern/${id}`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
  /**
   * 単体登録
   *
   * @param {TZyutuHaisyaPutReq} data
   * @param {(param: TApiResponse<TKyotenRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TKyotenRes>>) => any} reject
   * @memberof zyutyuHaisyaService
   */
  post = async (data: TZyutyuHaisyaPatternPutReq) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
        `/order/zyutyuhaisyapattern`,
        data
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
  /**
   * グリッド登録
   *
   * @param {TMenuInfoGetReq} params
   * @memberof MenuService
   */
  postPattern = async (id: number, param: { パターンコード: string }) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.postInner(
        `/order/zyutyuhaisya/actions/postpattern/${id}`,
        param
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 削除
   *
   * @param {TZyutyuHaisyaPatternPutReq} data
   * @param {(param: TApiResponse<TKyotenRes>) => any} resolve
   * @param {(param: AxiosError<TApiResponse<TKyotenRes>>) => any} reject
   * @memberof KyotenService
   */
  delete = async (id: string) => {
    try {
      const res: AxiosResponse<TApiResponse<boolean>> = await this.putInner(
        `/order/zyutyuhaisyapattern/actions/delete/${id}`,
        id
      )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
